const translations = {
  title: 'Novo Questionário',
  title_edit: 'Editando Questionário',
  'questionsStep.title': 'Categorias e perguntas',
  'questionsStep.subtitle': 'Construa a estrutura do questionário',
  'fieldsStep.name': 'Nome',
  'fieldsStep.type': 'Tipo',
  'fieldsStep.title': 'Informações Básicas',
  'fieldsStep.subtitle': 'Preencha as informações do questionário',
  'fieldsStep.allowReview': 'Permite revisão baseada na última atividade',
  'fieldsStep.sendEmail': 'Enviar notificação por email ao concluir o checklist',
  'fieldsStep.usages': 'Vou utilizar esse questionário em',
  'fieldsStep.description': 'Descrição',
  'fieldsStep.icon': 'Ícone',
  'fieldsStep.requireCheckin': 'Exigir validação de QR Code do local para executar esse checklist no app',
  'fieldsStep.allowBulkExecution': 'Permite execução em massa',
  'fieldsStep.allowBulkExecutionConditionalLogicHint':
    'Questionários habilitados para execução em massa não podem utilizar lógicas condicionais.',
  'fieldsStep.allowBulkExecutionConditionalLogicBlocked':
    '🚨 Este questionário possui perguntas com lógicas configuradas. Para permitir a execução em massa, é necessário remover todas as lógicas do questionário. Após realizar o ajuste, volte e ative novamente esta opção.',
  'fieldsStep.setRuntime': 'Tempo de execução deste questionário',
  'fieldsStep.enabledSegwareTestMode': 'Habilitar modo de teste da Segware',
  'fieldsStep.segwarePermittedExecutionTime': 'Tempo de execução do modo de teste',
  'fieldsStep.calendarViewActive': 'Adicionar cor de fundo no evento do calendário',
  'fieldsStep.calendarViewBgColor': 'Selecione a cor',
  usageForm: 'Formulários',
  usageServiceOrder: 'Atividades',
  usageActionPlan: 'Plano de Ação',
  dragQuestionsHere: 'Arraste as perguntas aqui',
  addCategory: 'Add Categoria',
  clone: 'Clonar',
  remove: 'Remover',
  question: 'Pergunta',
  questionSettings: 'Configurações da Pergunta',
  required: 'Obrigatório',
  requiredDocument: 'Documento obrigatório',
  useSavedUserSignature: 'Preencher com assinatura do perfil do usuário',
  confidential: 'Confidencial',
  allowNA: 'Permitir N/A',
  allowOnlyQrCodeOperations: 'Permitir apenas operações via QR Code',
  displayAsDropdown: 'Exibir como lista suspensa',
  allowMultipleSelection: 'Permitir seleção múltipla',
  noLineBreak: 'Não permitir quebra de linha',
  useMarkdown: 'Usar markdown',
  dontAllowReview: 'Não permitir revisão',
  filterByActivityPlace: 'Filtrar pelo local da atividade',
  annotations: 'Anotações',
  allowAnnotations: 'Permite anotações',
  requiredAnnotations: 'Anotações obrigatórias',
  'validationCode.title': 'Validação',
  'validationCode.validateWithParentId': 'Validar usando o ID da atividade pai',
  filterByAdditionalField: 'Filtro por Campo Adicional',
  selectAdditionalField: 'Selecione o campo adicional',
  selectOperator: 'Selecione o operador',
  value: 'Valor',
  addFilter: 'Adicionar filtro',
  additionalField: 'Campo adicional',
  removeFilter: 'Remover filtro',
  folder: 'Pasta',
  noFolder: 'Sem pasta',
  calcWarning: 'Esse tipo de pergunta não pode ser usado entre categorias diferentes ou dentro de blocos.',
  'operator.equal': 'Igual a',
  'operator.notEqual': 'Diferente de',
  'operator.greaterThan': 'Maior que',
  'operator.lessThan': 'Menor que',
  'operator.lessThanOrEqual': 'Menor ou igual a',
  'operator.greaterThanOrEqual': 'Maior ou igual a',
  validationNameRequired: 'Nome obrigatório',
  validationSelectUsage: 'Selecione como quer usar o questionário',
  validationSelectType: 'Selecione o tipo do questionário',
  validationSelectCalendarColor: 'Selecione a cor de fundo no evento do calendário',
  validationAddAtLeastOneCategory: 'Favor adicionar pelo menos uma categoria',
  validationGroupsWithoutCategory: 'Questionário possui grupos sem categoria selecionada',
  validationCategoriesWithoutQuestions: 'Categorias não podem ficar sem perguntas',
  validationQuestionsWithoutLabel: 'Questionário possui perguntas sem rótulo',
  validationInvalidConditions:
    'Questionário possui logicas ou configuração de não conformidades com opções que não existem mais. Verifique as perguntas de Seleção Unica e Multipla Escolha.',
  validationQuestionsWithoutOptions: 'Questionário possui perguntas de seleção ou multipla escolha sem opções',
  validationEmptyBlocks: 'Não é permitido perguntas de bloco vazio',
  validationBlocksInBlocks: 'Não é permitido blocos dentro de blocos',
  validationEmptyCalc: 'Questionário possui perguntas de cálculo sem fórmula',
  validationEmptyIntegration: 'Questionário possui perguntas de integração sem configuração',
  selectCategory: 'Selecione uma categoria',
  selectQuestionToEdit: 'Selecione uma pergunta para edita-la',
  categoryLabel: 'categoria',
  questionLabel: 'pergunta',
  'removeModal.multipleAutomationsAffected': 'As seguintes automações serão afetadas pela remoção da {{removingType}}',
  'removeModal.singleAutomationAffected': 'A seguinte automação será afetada pela remoção da {{removingType}}',
  'removeModal.confirmContinue': 'Tem certeza que deseja continuar?',
  'removeModal.removeCategoryWarning':
    'Ao remover esta categoria, todas as perguntas vinculadas serão excluídas. Tem certeza que deseja continuar?',
  ifAnswerIs: 'Se a resposta for:',
  addLogic: 'Adicionar lógica',
  addLogicBlockedByBulkExecution:
    'Questionários habilitados para execução em massa não podem utilizar lógicas condicionais entre perguntas.',
  updateLogic: 'Atualizar lógica',
  multipleChoiceOptions: 'Opções de múltipla escolha',
  questionInfo: 'Informações da pergunta',
  description: 'Descrição',
  fileOrImage: 'Arquivo ou Imagem',
  add: 'Adicionar',
  noCategoryDefined: 'Sem categoria definida',
  defaultValue: 'Valor inicial',
  removeDefaultValue: 'Remover valor inicial',
  calculation: 'Cálculo',
  formula: 'Fórmula',
  calcNote: 'Obs: Utilize números com o seguinte padrão',
  calcMinFieldsRequired: 'É necessário no mínimo 2 campos numéricos para ter um resultado.',
  numericSettings: 'Configurações numéricas',
  minValue: 'Valor mínimo',
  maxValue: 'Valor máximo',
  labels: 'Rotulos',
  'labels.yesNo': 'Sim/Não',
  'labels.compliant': 'Conforme',
  'labels.nonCompliant': 'Não Conforme',
  'labels.compliantNonCompliant': 'Conforme/Não Conforme',
  'labels.approved': 'Aprovado',
  'labels.rejected': 'Reprovado',
  'labels.approvedRejected': 'Aprovado/Reprovado',
  'labels.positive': 'Positivo',
  'labels.negative': 'Negativo',
  'labels.positiveNegative': 'Positivo/Negativo',
  photoSettings: 'Configurações de Foto',
  minQuantity: 'Quantidade min',
  allowPhotos: 'Permite fotos',
  requiredPhotos: 'Fotos obrigatórias',
  allowGalleryPhotos: 'Permitir fotos da galeria',
  configurationTags: 'Tags de configuração',
  filters: 'Filtros',
  isNonComplianceWhenAnswerIs: 'É não conformidade quando resposta for:',
  removeConfiguration: 'Remover configuração',
  configureMask: 'Configurar máscara',
  integration: 'Integração',
  service: 'Serviço',
  field: 'Campo',
  operationType: 'Tipo de operação',
  legacyQuestionTypeTitle: 'Tipo de pergunta descontinuada!',
  legacyQuestionTypeMessage:
    'Para obter o mesmo resultado, escolha a pergunta do tipo **Texto** e aplique a **Máscara** desejada.',
  questionNumber: 'Pergunta #{{number}}',
  addQuestionLabel: 'Adicionar rótulo da pergunta...',
  containsLogic: 'Contém lógica',
  questionWithNonComplianceConfig: 'Pergunta com configuração de não conformidade',
  predefinedDefaultValue: 'Valor inicial pré definido',
  questionsRemaining: '🚨 Você ainda pode adicionar **{{remaining}}** de **{{total}}** perguntas',
  previewMessage: 'Deseja ver como vai ficar o formulário final?',
  preview: 'Pré visualizar',
  selectTemplate: 'Selecione um template',
  'autofill.title': 'Preenchimento automático',
  'autofill.dataSource': 'Fonte de dados',
  'autofill.sourceUser': 'Perfil do Usuário',
  'autofill.sourcePlace': 'Cadastro do Local',
  'autofill.sourceServiceOrder': 'Campos da Atividade',
  'autofill.selectSource': 'Selecione a fonte',
  'autofill.field': 'Campo (origem)',
  'autofill.editable': 'Campo editável',
  'autofill.updateBase': 'Atualizar na Base',
  'autofill.updateBaseWarning': 'Alterações do técnico no app atualizarão o cadastro do usuário ou do local.',
  'autofill.removeConfig': 'Remover preenchimento automático'
}

export default translations
